import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.0",
  viewBox: "0 0 533 534"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M224 64.5V129h88V0h-88v64.5zM78.7 78.8 48 109.5l45.8 45.8 45.7 45.7 30.8-30.8 30.7-30.7-45.8-45.8L109.5 48 78.7 78.8zM378.7 93.8 333 139.5l31 31 31 31 45.8-45.8 45.7-45.7-31-31-31-31-45.8 45.8zM0 267v44h129v-88H0v44zM403.5 224.2c-.3.7-.4 20.4-.3 43.8l.3 42.5 64.8.3 64.7.2v-88h-64.5c-50.7 0-64.7.3-65 1.2zM93.7 378.8 48 424.5l31 31 31 31 45.8-45.8 45.7-45.7-31-31-31-31-45.8 45.8zM364.5 364l-31 31 45.8 45.8 45.7 45.7 31-31 31-31-45.8-45.8-45.7-45.7-31 31zM224 469.5V534h88V405h-88v64.5z" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "logo"}) } }